export const Loginsucces = "Login_success";
export const Loginfail = "Login_fail";
export const LoginRequest = "Login_Request";
export const Logout = "Logout";
export const Loadprofile = "Loadprofile";

export const HOME_VIDEOS_SUCCESS = "HOME_VIDEOS_SUCCESS";
export const HOME_VIDEOS_FAIL = "HOME_VIDEOS_FAIL";
export const HOME_VIDEOS_REQUEST = "HOME_VIDEOS_REQUEST";

export const VIDEOS_REQUEST_BY_IDSUCCESS = "HOME_VIDEOS_SUCCESS_BY_ID";
export const VIDEOS_REQUEST_BY_IDFAIL = "HOME_VIDEOS_FAIL_BY_ID";
export const VIDEOS_REQUEST_BY_IDREQUEST = "HOME_VIDEOS_REQUEST_BY_ID";

export const CHANNEL_DETAILS_REQUEST = "CHANNEL_DETAILS_REQUEST";
export const CHANNEL_DETAILS_SUCCESS = "CHANNEL_DETAILS_SUCCESS";
export const CHANNEL_DETAILS_FAIL = "CHANNEL_DETAILS_FAIL";

export const SET_SUBSCRIPTION_STATUS = "SET_SUBSCRIPTION_STATUS";

export const COMMENT_LIST_REQUEST = "COMMENT_LIST_REQUEST"
export const COMMENT_LIST_SUCCESS = "COMMENT_LIST_SUCCESS"
export const COMMENT_LIST_FAIL = "COMMENT_LIST_FAIL"

export const CREATE_COMMENT_SUCCESS = "CREATE_COMMENT_SUCCESS"
export const CREATE_COMMENT_FAIL = "CREATE_COMMENT_FAIL"

export const RELATED_VIDEO_REQUEST = 'RELATED_VIDEO_REQUEST'
export const RELATED_VIDEO_SUCCESS = 'RELATED_VIDEO_SUCCESS'
export const RELATED_VIDEO_FAIL = 'RELATED_VIDEO_FAIL'

export const SEARCH_VIDEO_REQUEST = 'SEARCH_VIDEO_REQUEST'
export const SEARCH_VIDEO_SUCCESS = 'SEARCH_VIDEO_SUCCESS'
export const SEARCH_VIDEO_FAIL = 'SEARCH_VIDEO_FAIL'

export const SUBCRIPTION_CHANNEL_REQUEST = 'SUBCRIPTION_CHANNEL_REQUEST'
export const SUBCRIPTION_CHANNEL_SUCCESS = 'SUBCRIPTION_CHANNEL_SUCCESS'
export const SUBCRIPTION_CHANNEL_FAIL = 'SUBCRIPTION_CHANNEL_FAIL'


export const CHANNEL_VIDEOS_REQUEST = 'CHANNEL_VIDEOS_REQUEST'
export const CHANNEL_VIDEOS_SUCCESS = 'CHANNEL_VIDEOS_SUCCESS'
export const CHANNEL_VIDEOS_FAIL = 'CHANNEL_VIDEOS_FAIL'

export const LIKE_VIDEO = 'LIKE_VIDEO'
export const DISLIKE_VIDEO = 'DISLIKE_VIDEO'
